// =============================================================================
// Lokalizacje (`public.locations`) — jedna definicja „aktywnej” po stronie TS.
//
// Most zakładów (migracja 791) zamienia usunięcie zakładu na ekranie Lokalizacje
// w `locations.status = 'inactive'` i lokalizacji nie kasuje (dokumenty i kursory
// mają na nią klucz obcy). Każdy, kto odpowiada na pytanie „ile lokalizacji ma
// klient” albo „który zakład wolno wybrać do nowego obiegu”, liczy więc wyłącznie
// AKTYWNE — tą samą regułą co SQL (`status = 'active'`, analityka najemców,
// strefa pieca Furnusa, odmowa `zaklad_nieaktywny` przy włączeniu obiegu).
//
// NULL nie jest aktywny: kolumna dopuszcza NULL, a CHECK `locations_status_check`
// go przepuszcza, więc „wszystko poza 'inactive'” byłoby inną regułą niż SQL.
// Mapa czytelników i ich decyzji: docs/02-ARCHITECTURE/MOST_ZAKLADOW.md §13.1a,
// pilnowana przez `tests/unit/supabase/czytelnicyStatusuLokalizacji.test.ts`.
// =============================================================================

/** Jedyna wartość `locations.status`, która znaczy „aktywna” (CHECK `locations_status_check`). NULL = nieaktywna. */
export const STATUS_AKTYWNEJ_LOKALIZACJI = 'active' as const;

/** Czy lokalizacja o tym statusie jest aktywna. NULL i brak pola → nie. */
export const czyLokalizacjaAktywna = (status: string | null | undefined): boolean =>
  status === STATUS_AKTYWNEJ_LOKALIZACJI;

/** Liczba AKTYWNYCH lokalizacji per organizacja z wierszy `{organization_id, status}`. */
export function aktywneLokalizacjeNaOrganizacje(
  wiersze: ReadonlyArray<{ organization_id: string; status: string | null }>
): Record<string, number> {
  const wynik: Record<string, number> = {};
  for (const w of wiersze) {
    if (!czyLokalizacjaAktywna(w.status)) continue;
    wynik[w.organization_id] = (wynik[w.organization_id] ?? 0) + 1;
  }
  return wynik;
}
